import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SidebarManager.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faTools,
  faBuilding,
  faWarehouse,
  faUsers,
  faUserCog,
  faMoneyBillWave,
  faChartBar,
  faBell,
  faEnvelope,
  faSignOutAlt,
  faChartLine,
  faDollarSign,
  faBars,
  faTimes,
  faClipboardList,
  faUserShield,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';

const ManagerSidebar = () => {
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();

  const toggleReportDropdown = () => setIsReportOpen(!isReportOpen);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Helper to highlight active link
  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <>
      {/* Mobile Toggle Button */}
      <button className="mobile-toggle" onClick={toggleSidebar} aria-label="Toggle Navigation Menu">
        <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} size="lg" />
      </button>

      {/* Sidebar Panel Container */}
      <aside className={`manager-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">TH</div>
          <div className="sidebar-brand">
            <span>GKM INVEST</span>
            <small>Management Panel</small>
          </div>
        </div>

        <nav className="sidebar-nav">
          <ul>
            <li className={isActive('/manager')}>
              <Link to="/manager">
                <div><FontAwesomeIcon icon={faTachometerAlt} /> <span>Dashboard</span></div>
              </Link>
            </li>

            {/* Core Operations Section */}
            <li className="nav-section-label">Core Operations</li>
            <li className={isActive('/manager/tenants')}>
              <Link to="/manager/tenants">
                <div><FontAwesomeIcon icon={faUsers} /> <span>Tenants</span></div>
              </Link>
            </li>
            <li className={isActive('/report_guards')}>
              <Link to="/report_guards">
                <div><FontAwesomeIcon icon={faUserShield} /> <span>Guard Management</span></div>
              </Link>
            </li>
            <li className={isActive('/manager/apartment-units')}>
              <Link to="/manager/apartment-units">
                <div><FontAwesomeIcon icon={faBuilding} /> <span>Apartment Units</span></div>
              </Link>
            </li>
            <li className={isActive('/manager/Maintenance')}>
              <Link to="/manager/Maintenance">
                <div><FontAwesomeIcon icon={faTools} /> <span>Maintenance</span></div>
              </Link>
            </li>
            <li className={isActive('/all-Materials')}>
              <Link to="/all-Materials">
                <div><FontAwesomeIcon icon={faWarehouse} /> <span>Materials</span></div>
              </Link>
            </li>
            <li className={isActive('/materialName')}>
              <Link to="/materialName">
                <div><FontAwesomeIcon icon={faClipboardList} /> <span>Register Material</span></div>
              </Link>
            </li>

            {/* Financials Section */}
            <li className="nav-section-label">Financials</li>
            <li className={isActive('/manager/Expences')}>
              <Link to="/manager/Expences">
                <div><FontAwesomeIcon icon={faMoneyBillWave} /> <span>Expenses</span></div>
              </Link>
            </li>

            <li className={isActive('/Booking_List')}>
              <Link to="/Booking_List">
                <div><FontAwesomeIcon icon={faBuilding} /> <span>Bookings</span></div>
              </Link>
            </li>

            {/* Dropdown Navigation Menu */}
            <li className={`dropdown-item ${isReportOpen ? 'expanded' : ''}`}>
              <div className="dropdown-trigger" onClick={toggleReportDropdown}>
                <div><FontAwesomeIcon icon={faChartBar} /> <span>Analytics</span></div>
                <FontAwesomeIcon icon={faChevronDown} className="arrow" />
              </div>
              {isReportOpen && (
                <ul className="sidebar-dropdown">
                  <li className={isActive('/reports/expenses')}>
                    <Link to="/reports/expenses">
                      <div><FontAwesomeIcon icon={faMoneyBillWave} /> <span>Expenses</span></div>
                    </Link>
                  </li>
                  <li className={isActive('/reports/income')}>
                    <Link to="/reports/income">
                      <div><FontAwesomeIcon icon={faDollarSign} /> <span>Income</span></div>
                    </Link>
                  </li>
                  <li className={isActive('/profit-loss-report')}>
                    <Link to="/profit-loss-report">
                      <div><FontAwesomeIcon icon={faChartLine} /> <span>Profit/Loss</span></div>
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Settings Section */}
            <li className="nav-section-label">Settings & Web</li>
            <li className={isActive('/manager/accounts')}>
              <Link to="/manager/accounts">
                <div><FontAwesomeIcon icon={faUserCog} /> <span>Accounts</span></div>
              </Link>
            </li>
            <li className={isActive('/ExpDetails')}>
              <Link to="/ExpDetails">
                <div><FontAwesomeIcon icon={faUserCog} /> <span>Add Expenses Category</span></div>
              </Link>
            </li>
            <li className={isActive('/manager/Home')}>
              <Link to="/manager/Home">
                <div><FontAwesomeIcon icon={faUserCog} /> <span>Home Page</span></div>
              </Link>
            </li>
            <li className={isActive('/manager/Slide')}>
              <Link to="/manager/Slide">
                <div><FontAwesomeIcon icon={faUserCog} /> <span>Slides</span></div>
              </Link>
            </li>
            <li className={isActive('/rental')}> 
              <Link to="/rental">
                <div><FontAwesomeIcon icon={faUserCog} /> <span>Sale Part</span></div>
              </Link>
            </li>

            {/* Communication Section */}
            <li className="nav-section-label">Communication</li>
            <li className={isActive('/notifctToTena')}>
              <Link to="/notifctToTena">
                <div><FontAwesomeIcon icon={faBell} /> <span>Notifications</span></div>
              </Link>
            </li>
            <li className={isActive('/manager/messagecontact')}>
              <Link to="/manager/messagecontact">
                <div><FontAwesomeIcon icon={faEnvelope} /> <span>Messages</span></div>
              </Link>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <Link to="/" className="logout-btn">
            <FontAwesomeIcon icon={faSignOutAlt} /> <span>Sign Out</span>
          </Link>
        </div>
      </aside>

      {/* Mobile Dark Overlay Mask */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default ManagerSidebar;